module.exports = __webpack_public_path__ + "static/media/tv.c75afdde.svg";